import React, { useEffect, useState } from "react";
// import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import Search from "../../../../components/search";
import Pagination from "../../../../components/tablePagination";
import { CompletedHeaders, filterList } from "../data";
import Button from "../../../../components/button";
import {
  noshowGroupAppointments,
  noshowRemoveGroupAppointments,
  resendSurveyEmail,
  updateInterviewReason,
} from "../../../../services/medium";
import { doAPayItForwardPayment,
  giftMediumForAppointment,
  payWithPaypalCompleted,
  payWithSquareCompleted,
  payWithStripeCompleted,
 } from "../../../../services/client";
import RefundDeleteModal from "../../../../components/refundConfirmModal";
import PayOptionsPopUp from "../../../../components/payoptionspopup";
import { toast } from "react-toastify";
import ConfirmCancel from "../../../admin/appointments/subcomponents/cancelpopup";
import {
  copyToClipboard,
  emptyAllSelectBox,
  session_id_beg,
  session_id_end,
} from "../../../../utils/helpers";
import { settlePaymentOutside } from "../../../../services/admin";
import { setLoading } from "../../../../reducer/auth/auth";
import NoshowBox from "../../../admin/appointments/subcomponents/noshowbox";
import WorkerBox from "../../../admin/appointments/subcomponents/workersbox";
import SettlePaymentOutsitePopup from "../../../admin/appointments/subcomponents/settleoutsidepopup";
import BackFillConfirmation from "../subcomponetnts/backfillconfirmation";
import Contactpopup from "../subcomponetnts/contactpopup";
import FloatingActionMenu from "../subcomponetnts/floatingActionMenu";
import ZoomLinkPopup from "../subcomponetnts/zoomlinkpopup";
import PayItForwardPopUp from "../../../client/appointments/components/payitforward";
import GiftYourMediums from "../../../client/appointments/components/giftyourmediums";

import { TablePagination } from "@mui/material";
import "./updateReasonModal.css";
export default function Completed(props) {
  const {
    completedAppointments,
    changeHandler,
    changeHandle1,
    onClickHandler,
    filterReset,
    filterListAppointments,
    getPaginationData,
    setFilterValues,
    setSearchValues,
    getAllAppointmentsList,
    activeTab,
    searchValue,
    filterValues,
    blockUser,
    goToMediumBackFill,
    setBlink,
    refundingCall,
    stopPaymentCall
  } = props;
  const { id } = useSelector((state) => state.user.user);
  const { id:curentUser } = useSelector((state) => state.user.user);
  // const copyMeetingLink = (url) => {
  //   navigator.clipboard.writeText(url);
  // };
  const { allCompletedCount } = useSelector((state) => state.medium);
  const [active, setActive] = useState({});
  // anchor element of the open "..." actions menu (menu is rendered in a portal)
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [appType, setAppType] = useState("");
  const [attendeesList, setattendeesList] = useState([])
  const [noshowFrom, setNoShowFrom] = useState('');
  const [noShowActive, setNoShowActive] = useState();
  const [settlePaymentLocalId, setsettlePaymentLocalId] = useState('')
  const [backFillId, setBackFillId] = useState('');
  const [selectedMedium, setSelectedMedium] = useState();
  const [isRefund, setIsRefund] = useState(0);
  // See the matching comment in pages/medium/appointments/upcoming/index.js —
  // refunding/waiving a specific attendee only patches the parent list's
  // attendees[], not the separate `attendeesList` snapshot NoshowBox
  // renders, so this tracks whether the in-flight confirm targets an
  // attendee so a full refetch can be triggered on success.
  const [isAttendeeAction, setIsAttendeeAction] = useState(false);
  const [activeContact, setactiveContact] = useState('');

  // "Update reason" popup - only shown for subsession_table_id == 100
  // rows where the logged-in medium is also the interviewer on that
  // appointment (medium_id). activeReasonAppointment is the row currently
  // being edited, mirroring the activeContact pattern above.
  const [activeReasonAppointment, setActiveReasonAppointment] = useState(null);
  const [selectedReason, setSelectedReason] = useState("");
  const [savingReason, setSavingReason] = useState(false);

  const [activePay, setActivePay] = useState("");
  const [paymentstatus, setPaymentstatus] = useState(false);
  const [payItforwardValue, setpayItforwardValue] = useState('');
  const [payItforwardFixPrice, setpayItforwardFixPrice] = useState("")
  const [paymentCurrency, setPaymentCurrency] = useState('USD');
  const [giftAmount, setGiftAmount] = useState('');
  const [dataToDisplay, setDataToDisplay] = useState([]);
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);


  useEffect(() => {
    setBlink(false)
    // window.loadModal2("#BackFillConfirmationTime", "show");
  }, [])
  useEffect(() => {
  
      const start = (page - 1) * rowsPerPage;
      const end = page * rowsPerPage;
      setDataToDisplay(completedAppointments.slice(start, end));
    }, [completedAppointments])
  const handleNoShow = (e, appoinment) => {
    setBackFillId(appoinment.id)
    setSelectedMedium(appoinment.medium_id)
    setAppType(appoinment.session_type);
    let value = e.target.value;
    if(value == "settle_outside"){
      settlePaymentLocal(appoinment.id);
      return;
    }
    if(value === "refund"){
      setIsRefund(1);
      setIsAttendeeAction(false);
      // if(appoinment.survey_status_type == 0){
        window.loadModal2("#ConfirmRefundAppointment", "show");
        return;
      // }else{
      //     refundingCall(appoinment.medium_id, appoinment.id);
      //     return;
      // }


    }
    if(value === "stop_payment_request"){
      setIsRefund(0);
      setIsAttendeeAction(false);
      //  if(appoinment.survey_status_type == 0){
        window.loadModal2("#ConfirmRefundAppointment", "show");
        return;
      //  } else{
      // stopPaymentCall(appoinment.medium_id, appoinment.id);
      // return;
      //  }
    }
      if(value === "stop_payment_request"){
      toast.success("Status updated successfully", {
  position: "top-center",
});
      return;
    }
    console.log(value, "values");
    let noShowBy = value;
    if (value === "me") {
      if (appoinment.session_type === "1" || appoinment.session_type === "2") {
        // if (userid === clientid) send mediumid
        // if(userid !== clientid ) send clientid
        // if (parseInt(id) === parseInt(appoinment.client_id)) {
        changeHandlerLocal1(
          e,
          2,
          appoinment.appointmentId,
          id,
          "medium",
          "medium_id",
          appoinment.session_type,
          noShowBy
        );
      } else {
        changeHandlerLocal(
          e,
          2,
          appoinment.appointmentId,
          appoinment.medium_id,
          "medium",
          "medium_id",
          appoinment.session_type,
          noShowBy
        );
      }
    } else if (value === "give-add-1") {
      changeHandlerLocal(
        e,
        6,
        appoinment.appointmentId,
        appoinment.medium_id,
        "medium",
        "medium_id",
        appoinment.session_type,
        noShowBy
      );
    } else if (value === "restrict-client") {
      changeHandlerLocal(
        e,
        5,
        appoinment.appointmentId,
        appoinment.medium_id,
        appoinment.session_type,
        noShowBy
      );
    } else {
      if (appoinment.session_type === "1" || appoinment.session_type === "2" || appoinment.session_type == "11" || appoinment.session_type == "16" || appoinment.session_type == "34") {
       
        
        // if (userid === clientid) send mediumid
        // if(userid !== clientid ) send clientid
        if (parseInt(id) === parseInt(appoinment.medium_id)) {
          changeHandlerLocal1(
            e,
            2,
            appoinment.appointmentId,
            appoinment.client_id,
            "medium",
            "medium_id",
            appoinment.session_type,
            noShowBy
          );
        } else {
          changeHandlerLocal1(
            e,
            2,
            appoinment.appointmentId,
            appoinment.medium_id,
            "medium",
            "medium_id",
            appoinment.session_type,
            noShowBy
          );
        }

        // if (userid === clientid) send mediumid
        // if(userid !== clientid ) send clientid
      } else {
        changeHandlerLocal(
          e,
          2,
          appoinment.appointmentId,
          appoinment.client_id,
          "medium",
          "client_id",
          appoinment.session_type,
          noShowBy
        );
      }
    }
  };

  const changeHandlerLocal1 = (
    e,
    type,
    id,
    targetId,
    targetType,
    targetTypeID,
    sessionType,
    noShowBy
  ) => {
    setActive({ e, type, id, targetId, targetType, targetTypeID, sessionType, noShowBy });
    window.loadModal2("#ConfirmCancelcompletedmedium", "show");
  };

  const changeHandlerLocal = (
    e,
    type,
    id,
    targetId,
    targetType,
    targetTypeID,
    sessionType,
    noShowBy
  ) => {
    setActive({ e, type, id, targetId, targetType, targetTypeID, sessionType, noShowBy });
    window.loadModal2("#ConfirmCancelcompletedmedium", "show");
  };

  const cancelRequest = () => {
    window.loadModal2("#ConfirmCancelcompletedmedium", "hide");
    window.loadModal2("#ConfirmRefundAppointment", "hide");
    emptyAllSelectBox();
  };
  const confirmRequest = () => {
    let { e, type, id, targetId, targetType, targetTypeID, sessionType, noShowBy } = active;
    if (parseInt(appType) === 1 || parseInt(appType) === 2 || parseInt(appType) === 11 || parseInt(appType) === 16 || parseInt(appType) === 34) {
      changeHandle1(e, type, id, targetId, targetType, targetTypeID, sessionType, noShowBy);
    } else {
      changeHandler(e, type, id, targetId, targetType, targetTypeID, sessionType, noShowBy);
    }
  };

  const resendSurveyLink = (id) => {
    let body = {
      appointment_id: id,
      // survey_link
    };
    resendSurveyEmail(body)
      .then((data) => {
        if (data.data.status) {
          toast.success("Survey Sent Succesfully", {
            position: "top-center",
          });
          // getLink();
        }
      })
      .catch(() => { });
  };
  const settlePayment = (id) => {
    dispatch(setLoading(true));
    settlePaymentOutside(id).then((data) => {
      dispatch(setLoading(false));
      if (data.data.status) {
        toast.success("Appointment Updated Successfully!!", {
          position: "top-center",
        });
        const info = {
          page: 1,
          rowsPerPage: 10,
        };
        getAllAppointmentsList(info, activeTab);
      } else {
        toast.error(data.data.message, {
          position: "top-center",
        });
      }
    });
  };
  const coptText = (value) => {
    copyToClipboard(value);
    toast.success("E-mail Copied", { position: "top-center" });
  };

  const openNoShowBox = (list, from, item) => {
    if (item.subsession_table_id === 101) {
      return;
    }
    setNoShowActive(item);
    setNoShowFrom(from);
    setattendeesList(list)
    window.loadModal('#NoshowBox', 'show');
  }
  const openWorkerBox = (list, from, item) => {
    
    setNoShowActive(item);
    setNoShowFrom(from);
    setattendeesList(list)
    window.loadModal('#WorkerBox', 'show');
  }
  
  const noshowGroupAppointment = (item) => {
    console.log(item);
    let body = {
      appointment_id: noShowActive.id,
      user_id: item.user_id
    }
    noshowGroupAppointments(body).then((data) => {
      if (data.data.status) {
        toast.success("Status updated succesfully", {
          position: "top-center",
        });
        const data = {
          page: 1,
          rowsPerPage: 10,
        };
        getAllAppointmentsList(data, activeTab,);
      }
      else {
        toast.error("Something went wrong", { position: "top-center" });
      }
    })
  }
  const noshowRemoveGroupAppointment = (item) => {
    console.log(item);
    let body = {
      appointment_id: noShowActive.id,
      user_id: item.user_id
    }
    noshowRemoveGroupAppointments(body).then((data) => {
      if (data.data.status) {
        toast.success("Status updated succesfully", {
          position: "top-center",
        });
        const data = {
          page: 1,
          rowsPerPage: 10,
        };
        getAllAppointmentsList(data, activeTab,);
      }
      else {
        toast.error("Something went wrong", { position: "top-center" });
      }
    })
  }
  const checkAppId = (appoinment) => {
    if (appoinment.is_group_session === 0) {
      return appoinment.id
    }
    else if (appoinment.is_group_session === 1) {
      
        if (appoinment.parent_id == null) {
          return appoinment.id
        }
        else {
          return appoinment.parent_id
        }

     

    }
    else {
      return appoinment.id
    }

  }

  const settlePaymentLocal = (id) => {

    window.loadModal2("#SettlePaymentOutsitePopup", "show");
    setsettlePaymentLocalId(id)
  }
  const settleoutsidepopupconfirmRequest = () => {
    settlePayment(settlePaymentLocalId);
  }

  const settleoutsidepopupcancelRequest = () => {
    window.loadModal2("#SettlePaymentOutsitePopup", "hide");
    
  }
  const openContactPopup = (item) => {
    window.loadModal2("#Contactpopup", "show")
    setactiveContact(item)
  }
  const openZoomLinkPopup = (item) => {
    window.loadModal2("#ZoomLinkPopup", "show")
    setactiveContact(item)
  }
  const openUpdateReasonPopup = (item) => {
    setActiveReasonAppointment(item);
    setSelectedReason(item.interview_reason || "");
    window.loadModal2("#UpdateReasonModal", "show");
  };
  const closeUpdateReasonPopup = () => {
    window.loadModal2("#UpdateReasonModal", "hide");
  };
  const saveUpdateReason = async () => {
    if (!selectedReason || savingReason || !activeReasonAppointment) return;

    setSavingReason(true);
    let updated = false;

    try {
      const payload = {
        appointment_id: activeReasonAppointment.appointmentId || activeReasonAppointment.id,
        reason: selectedReason,
      };

      const response = await updateInterviewReason(payload);
      const res = response || {};
      // the service returns the axios error object itself on failure
      const errResponse = res.response || {};
      const resData = errResponse.data || res.data || {};
      const message = resData.message || res.message;

      if (errResponse.status || resData.status === false) {
        toast.error(message || "Unable to update reason.", {
          position: "top-center",
        });
        return;
      }

      const movedToNoShow =
        (resData.data && resData.data.moved_to_no_show) ||
        selectedReason === "No Show";
      toast.success(
        movedToNoShow
          ? "Interview marked as No Show and moved to the No Show tab."
          : message || "Reason updated.",
        { position: "top-center" }
      );
      updated = true;
    } catch (error) {
      toast.error("Unable to update reason.", { position: "top-center" });
    } finally {
      setSavingReason(false);
    }

    if (updated) {
      setSelectedReason("");
      closeUpdateReasonPopup();
      const info = {
        page: 1,
        rowsPerPage: 10,
      };
      getAllAppointmentsList(info, activeTab);
    }
  };
  const priceCheck = (item) => {
    let prices = item.amount
    let cur = item.currency;
    // let prices = item.session_length !== undefined && item.session_length !== "" && item.session_length !== null ? Object.values(
    //   JSON.parse(item.session_length)
    // )[0] : 20
    // let cur = item.session_currency !== undefined && item.session_currency !== "" && item.session_currency !== null ? Object.values(
    //   JSON.parse(item.session_currency)
    // )[0] : 'USD'
    let price = prices !== "" && prices !== null ? prices : 20
    let currency = cur !== "" && cur !== null ? cur : 'USD'
    return `Pay $ ${price} ${currency} `
  }
  const openPaymentModal = (item) => {
    setActivePay(item);
    if (item.is_pay_forward) {
      // if (item.payitforward_pricing !== null) {
      //   const cleanString = item.payitforward_pricing.slice(1, -1); // remove the outer quotes
      //   const parsedString = cleanString.replace(/\\/g, ''); // remove backslashes

      //   // Step 2: Parse the cleaned string into an object
      //   let parsedPricing;
      //   try {
      //     parsedPricing = JSON.parse(parsedString);
      //   } catch (error) {
      //     console.error("Error parsing JSON:", error);
      //   }
      //   let priceValue = parsedPricing[item.duration];
        setpayItforwardValue(item.amount !== null ? item.amount : '');
        setpayItforwardFixPrice(item.amount !== null ? item.amount : '');
        window.loadModal2("#PayItForwardPopUp", "show");
      // } else {
        // setpayItforwardFixPrice(item.payitforward_pricing !== null ? '' : '');
        // setpayItforwardValue(item.payitforward_pricing !== null ? '' : '');
        // window.loadModal2("#f", "show");
      // }

      return;
    }
   window.loadModal2("#payoptionspopup", "show");
  }
  // "Gift Your Medium" for prepaid professional sessions this medium booked as a client.
  // The prepayment is already settled, so the gift has its own endpoint.
  const openGiftModalForPrepaid = (item) => {
    setActivePay(item);
    setGiftAmount('');
    setPaymentstatus(!paymentstatus);
    window.loadModal2("#GiftYourMediums", "show");
  }
  const giftPaymentMethodHandler = (type) => {
    if (!(giftAmount > 0)) {
      toast.error("Amount cannot be less than or equal to zero", {
        position: "top-center",
      });
      return;
    }
    giftMediumForAppointment({
      appointment_id: activePay.id,
      amount: giftAmount,
      method: type,
    })
      .then((data) => {
        if (data.data.status) {
          window.open(data.data.data.redirectUrl, "_self");
        } else {
          toast.error(data.data.message, {
            position: "top-center",
          });
        }
      })
      .catch(() => { });
  }
   const payItForwardHandler = () => {
      let appoinmentType;
      if (activePay.session_type == "5") {
        appoinmentType = 'donated'
      } else {
        appoinmentType = 'payafter'
      }
      let body = {
        medium_id: activePay.medium_id,
        appointment_id: activePay.id,
        amount: payItforwardValue,
        appointment_type: appoinmentType
      }
      doAPayItForwardPayment(body).then((data) => {
        if (data.data.status) {
          window.open(data.data.data.approvedUrl, "_self");
          // openWaitingContainer();
        }
      }).catch(() => {
  
      })
    }
    const runCallback = (type) => {
    
        console.log(activePay, "")
        let body = {
          id: activePay.id,
          medium_id: activePay.medium_id,
          amount: activePay.amount,
          currency: activePay.currency,
          appointment_type: 'payafter',
          client_id: id,
        };
        if (type === "paypal") {
          payWithPaypalCompleted(body)
            .then((data) => {
              console.log(data.data, "cdqe")
              if (data.data.status) {
                
                // window.loadModal2("#payoptionspopup", "hide");
                window.open(data.data.data.approvedUrl, "_self");
              }
              else {
                toast.error(data.data.message, {
                  position: "top-center",
                });
              }
            })
            .catch(() => { });
        } else if (type === "stripe") {
          payWithStripeCompleted(body)
            .then((data) => {
              if (data.data.status) {
                
                // window.loadModal2("#payoptionspopup", "hide");
                window.open(data.data.data.approvedUrl, "_self");
              }
              else {
                toast.error(data.data.message, {
                  position: "top-center",
                });
              }
            })
            .catch(() => { });
        }
        else {
          payWithSquareCompleted(body)
            .then((data) => {
              if (data.data.status) {
                
                // window.loadModal2("#payoptionspopup", "hide");
                window.open(data.data.data.approvedUrl, "_self");
              }
              else {
                toast.error(data.data.message, {
                  position: "top-center",
                });
              }
            })
            .catch(() => { });
        };
      }
  const handleChangePage = (
    event,
    newPage
  ) => {
    console.log(newPage, "event")
    setPage(newPage + 1);
  };
  const handleChangeRowsPerPage = (
    event
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };
  useEffect(() => {
      const start = (page - 1) * rowsPerPage;
      const end = page * rowsPerPage;
      setDataToDisplay(completedAppointments.slice(start, end));
    }, [page, rowsPerPage]);
var checkStatus0Values = function (data) {
  if (data && data.attendees && Array.isArray(data.attendees)) {
    return data.attendees.filter(function (info) {
      return info.status == 1;
    });
  }
  return [];
};

var checkWorkersValues = function (data) {
  if (data && data.workers && Array.isArray(data.workers)) {
    return data.workers.filter(function (info) {
      return info.status == 1;
    });
  }
  return [];
};
    // The master appointment lists get patched fine (patchPaymentStatus in
    // pages/medium/appointments/index.js), but the already-open NoshowBox
    // modal renders a separate `attendeesList` snapshot taken when it was
    // opened, which that patch never touches — so this also patches
    // attendeesList directly, which is what's actually on screen, instead of
    // depending on a refetch + the modal being reopened.
    const refreshAfterAttendeePayment = () => {
      setIsAttendeeAction(false);
      setattendeesList((prev) =>
        prev.map((attendee) =>
          attendee.id === backFillId
            ? { ...attendee, payment_status: "Refunding" }
            : attendee
        )
      );
    };
    const confirmAppt = () => {
      // goToMediumBackFill(backFillId, appType);
      // cancelRequest();
      const onSuccess = isAttendeeAction ? refreshAfterAttendeePayment : undefined;
      if(isRefund){
        refundingCall(selectedMedium, backFillId,  false, onSuccess);
      } else {
        stopPaymentCall(selectedMedium, backFillId, false);
      }
    }
    const confirmApptNo = () => {
      // goToMediumBackFill(backFillId, appType);
      // cancelRequest();
      const onSuccess = isAttendeeAction ? refreshAfterAttendeePayment : undefined;
      if(isRefund){
        refundingCall(selectedMedium, backFillId,  true, onSuccess);
      } else {
        stopPaymentCall(selectedMedium, backFillId, true);
      }
    }
    // Refund for one attendee inside a group session's attendee list
    // (NoshowBox). No waive here: group sessions are pay-to-book, so there's
    // no outstanding/unpaid attendee state to waive.
    const refundAttendee = (item) => {
      setBackFillId(item.id);
      setSelectedMedium(item.medium_id);
      setIsRefund(1);
      setIsAttendeeAction(true);
      window.loadModal2("#ConfirmRefundAppointment", "show");
    };
  return (
    <>
      {console.log(backFillId, "backFillId")}

      <div className="table-box-medium admin-appoi" style={{ overflow: "visible" }}>
        <div className="appt-table-scroll" style={{ overflowX: "scroll", width: "100%" }}>
        <table className="caseTable">
          <tbody>
            <tr className="dark">
              {React.Children.toArray(
                CompletedHeaders.map((item) => <th>{item.title}</th>)
              )}

              {/* <input type="checkbox" id="one" />
                <label htmlFor="one"></label> */}
            </tr>
            {completedAppointments.length > 0 ? (
              completedAppointments.map((appoinment, index) => (
                <tr className={`innr ${appoinment.is_worker_appointment == 1 ? "isWorkedBG" : "" }`}>
                  <td>
                    {session_id_beg + checkAppId(appoinment) + session_id_end}
                    {appoinment.give_add1_highlight ? (
                      <img
                        className="ml-1 star-app-hightlight"
                        src="../images/star.png"
                      />
                    ) : (
                      ""
                    )}
                  </td>
                  <td>
                   
                   
                  {appoinment.attendees == undefined ?
                    <>
                    <span className="capitalize">{appoinment.client_name},</span>
                    <br />
                    <span className="capitalize">{appoinment.medium_name}</span>
                    </>
                    :
                     <>
                      {appoinment &&
 Array.isArray(appoinment.attendees) &&
 appoinment.attendees.length > 0&& (
                    <span className="text-underline  pointer p-1" onClick={() => openNoShowBox(appoinment.attendees, '', appoinment)}>{checkStatus0Values(appoinment).length}&nbsp;Attendee(s)</span>
                     )}
                    <br />
                    {appoinment && Array.isArray(appoinment.workers) && appoinment.workers.length > 0 && (
                     <span className="text-underline  pointer p-1" onClick={() => openWorkerBox(appoinment.workers, '', appoinment)}>{checkWorkersValues(appoinment).length}&nbsp;Worker(s)</span>
                     )}
                    </>
                  }
                  </td>
                  <td>
                    <div style={{ fontWeight: '500' }}>{appoinment.date.split(" ")[0]}</div>
                    <div style={{ color: '#666', fontSize: '13px', marginTop: '2px' }}>{appoinment.time}</div>
                  </td>
                  <td style={{ whiteSpace: "normal", wordBreak: "break-word", minWidth: 160, maxWidth: 220 }}>{appoinment.session_name}</td>

                  <td>
                    {(appoinment.attendees == undefined || appoinment.subsession_table_id == 99 || appoinment.subsession_table_id == 101) && appoinment.subsession_table_id != 102 && appoinment.subsession_table_id != 96 && appoinment.session_type != 34 ?
                      <>
                        {" "}
                        {appoinment.survey_link == null && appoinment.survey_status_type == 1 ? (
                        <div className="color-d5a67b justify-content-center d-flex align-items-center height-45">
                          Exempt
                        </div>
                      ) :(appoinment.session_type === "16" || (appoinment.subsession_table_id != 93 && appoinment.session_type === "1")  || (appoinment.subsession_table_id == 99) || (appoinment.subsession_table_id == 101) ||
                          (appoinment.session_type === "2" && appoinment.client_id == id)) &&
                          (appoinment.survey_status === "pending" || appoinment.survey_status === "pending_change_label")  ? (
                          <a
                            className={`resend-btn w-140 d-inline-flex align-items-center justify-content-center`}
                            target="_blank"
                            href={appoinment.survey_link}
                          >
                            {appoinment.survey_status === "pending_change_label" ? "Update Survey" : "Take Survey"}
                          </a>
                        ) : (
                          <>
                          <div className="`justify-content-center d-flex align-items-center height-45 capitalize ${appoinment.subsession_table_id !== 93 ? 'color-d5a67b' : ''}`}">
                            {appoinment.subsession_table_id != 93 && appoinment.subsession_table_id != 102 ? appoinment.survey_status : "N/A"}
                          </div>
                          
                        </>
                        )}
                      </>
                      : 'N/A'
                    }
                  </td>
                  <td>
                    {appoinment.attendees == undefined && appoinment.subsession_table_id != 102 && appoinment.payment_status != null && appoinment.payment_status != "" ?

                      <div className="color-d5a67b d-flex align-items-center height-45">
                          {appoinment.payment_status }
                      </div>
                      :
                      'N/A'
                    }
                  </td>
                  <td>
                    <>
                    {appoinment.attendees == undefined ?
                      <>
                        {/* Same fix as the Upcoming tab: this select's options all
                            come from conditions below (Paid Outside / Refunding /
                            Stop Payment Request). When none of them are true it
                            used to render a dropdown with only the disabled
                            "Select" placeholder in it - looks like a control but
                            has nothing to pick. Folding those same conditions
                            into the outer check so that case shows "N/A" instead. */}
                        {appoinment.is_group_session === 0 && (appoinment.session_type === "8" || appoinment.session_type === "7" || appoinment.is_extra_services == 1) &&
                          ((appoinment.payment_request_button === "Send Request" && (appoinment.session_type === "7" && appoinment.client_id != id)) ||
                            ((appoinment.session_type === "8" || appoinment.is_extra_services == 1) && appoinment.payment_status != "Refunding" && appoinment.client_id != curentUser) ||
                            (appoinment.session_type === "7" && appoinment.payment_status != "Refunding" && appoinment.payment_status != "Waived" && appoinment.client_id != curentUser)) ?
                          <select
                            // value={appoinment.statusValue}
                            onChange={(e) => handleNoShow(e, appoinment)}
                            className="appointment-select-box"
                          >
                            <option value="" selected disabled>
                              Select
                            </option>

                        {appoinment.payment_request_button === "Send Request" &&
                          (appoinment.session_type === "7" && appoinment.client_id != id) && (
                            <option value={"settle_outside"}>{"Paid Outside"}</option>
                          )}
                            {((appoinment.session_type === "8" || appoinment.is_extra_services == 1) && appoinment.payment_status != "Refunding" && appoinment.client_id != curentUser) && (
                              <>

                              <option value={"refund"}>{"Refunding"}</option>
                              </>
                            )}
                            {(appoinment.session_type === "7" && appoinment.payment_status != "Refunding" && appoinment.payment_status != "Waived" && appoinment.client_id != curentUser )&& (
                              <option
                                value={
                                  appoinment.payment_status === "Paid"
                                    ? "refund"
                                    : "stop_payment_request"
                                }
                              >
                                {appoinment.payment_status === "Paid"
                                  ? "Refunding"
                                  : "Stop Payment Request"}
                              </option>
                            )}




                          </select>
                          :
                          appoinment.attendees == undefined && appoinment.subsession_table_id != 102 && appoinment.payment_request_button === "Send Request" &&
                          appoinment.session_type === "7" && appoinment.client_id == id &&  appoinment.amount !== "0" && (
                            appoinment.transaction_status === null ||
                              appoinment.transaction_status === 0) || (appoinment.attendees == undefined && appoinment.subsession_table_id != 102 && appoinment.session_type == 8 && appoinment.client_id == id && appoinment.can_gift_medium) ? '':'N/A'
                        }
                      </>
                      :

                     appoinment.attendees == undefined && appoinment.subsession_table_id != 102 && appoinment.payment_request_button === "Send Request" &&
                          appoinment.session_type === "7" && appoinment.client_id == id &&  appoinment.amount !== "0" && (
                            appoinment.transaction_status === null ||
                              appoinment.transaction_status === 0) || (appoinment.attendees == undefined && appoinment.subsession_table_id != 102 && appoinment.session_type == 8 && appoinment.client_id == id && appoinment.can_gift_medium) ? '':'N/A'
                    }
                    {appoinment.attendees == undefined && appoinment.subsession_table_id != 102   ?
                      <>
                        {/* {appoinment.payment_request_button === "Send Request" &&
                          (appoinment.session_type === "7" && appoinment.client_id != id) && (
                            <Button
                              status={0}
                              onClick={(e) => settlePaymentLocal(appoinment.id)}
                              type="button"
                              className={`resend-btn height-35 w-140 mt-2`}
                              title={`Settle Outside`}
                            />
                          )} */}
                          {appoinment.payment_request_button === "Send Request" &&
                          appoinment.session_type === "7" && appoinment.client_id == id &&  appoinment.amount !== "0" && (
                            appoinment.transaction_status === null ||
                              appoinment.transaction_status === 0) && (
                            <Button
                              status={0}
                              onClick={(e) => openPaymentModal(appoinment)}
                              type="button"
                              className={`resend-btn height-35 w-140 mt-2`}
                              title={appoinment.is_pay_forward ? 'Pay' : priceCheck(appoinment)}
                            />
                          )}
                          {appoinment.session_type == 8 && appoinment.client_id == id && appoinment.can_gift_medium && (
                            <Button
                              status={0}
                              onClick={() => openGiftModalForPrepaid(appoinment)}
                              type="button"
                              className={`resend-btn height-35 w-140 mt-2`}
                              title={'Gift Your Medium'}
                            />
                          )}
                      </>
                      :

                      ''
                    }
                    </>
                  </td>
                  <td>
                    {appoinment.attendees == undefined ? (
                      appoinment.is_group_session === 0 ? (
                        <select
                          onChange={(e) => handleNoShow(e, appoinment)}
                          className="appointment-select-box"
                        >
                          <option value="" selected disabled>
                            Select
                          </option>

                          {appoinment.is_no_show && (
                            <option value={"me"}>{"No Show By Me"}</option>
                          )}
                          {appoinment.is_no_show && (
                            <option value={"other"}>
                              {appoinment.session_type === "1" ||
                                appoinment.session_type === "2" ||
                                appoinment.session_type === "16"
                                ? "No Show By Other Medium"
                                : "No Show By Other"}
                            </option>
                          )}

                          {appoinment.session_type === "5" ? (
                            <option value={"give-add-1"}>{"Give Add’l"}</option>
                          ) : (
                            ""
                          )}
                          {appoinment.session_type !== "1" &&
                            appoinment.session_type !== "2" &&
                            appoinment.session_type !== "3" &&
                            appoinment.session_type !== "11" &&
                            appoinment.session_type !== "16" &&
                            appoinment.medium_id == curentUser && (
                              <option value={"restrict-client"}>
                                {"Restrict client"}
                              </option>
                            )}
                        </select>
                      ) : (
                        'N/A'
                      )
                    ) : (
                      <Button
                        status={0}
                        onClick={() => openNoShowBox(appoinment.attendees, '', appoinment)}
                        type="button"
                        className={`resend-btn w-130`}
                        title="No Show"
                      />
                    )}
                  </td>
                  {/* <td>
                    <div>
                      <p className="d-flex">
                        <div> Client:</div>{" "}
                        <div className="d5a67b ml-1">
                          {appoinment.client_email}{" "}
                        </div>
                      </p>
                      <p className="d-flex">
                        {" "}
                        <div>Medium:</div>{" "}
                        <div className="d5a67b ml-1">
                          {appoinment.medium_email}
                        </div>
                      </p>
                    </div>
                  </td> */}
                  {/* <td>
                    <select
                      onChange={(e) =>
                        changeHandler(e, 2, appoinment.appointmentId)
                      }
                      className="appointment-select-box"
                    >
                      <option selected disabled>
                        Select
                      </option>
                      {Object.entries(appoinment.userArray).map((show) => (
                        <option value={show[0]}>{show[1]}</option>
                      ))}
                    </select>
                  </td> */}
                  <td className="position-relative ">
                    {appoinment.attendees == undefined ?
                      <>
                        {(appoinment.session_type === "1" ||
                          appoinment.session_type === "2" || appoinment.session_type === "16") && (
                            <span className="block-tooltip-wrap">
                              {" "}
                              <Button
                                status={0}
                                onClick={(e) =>
                                  blockUser(
                                    appoinment.id,
                                    appoinment.medium_id,
                                    appoinment.client_id
                                  )
                                }
                                type="button"
                                className={`resend-btn w-130 tooltip-2-focus`}
                                title={
                                  parseInt(appoinment.is_blocked) === 0
                                    ? "Block"
                                    : "Unblock"
                                }
                              />
                              <p className="tooltip-2 block-tooltip-app">
                                {parseInt(appoinment.is_blocked) === 0
                                  ? "Only click if you do not want to work with this person at all."
                                  : "Only click if you want to work this person."}
                              </p>
                            </span>
                          )}
                      </>
                      :
                      'N/A'
                    }
                  </td>
                  <td className="dot-image">
                    <img
                      onClick={(e) => {
                        setMenuAnchor(appoinment.status ? null : e.currentTarget);
                        onClickHandler(e, appoinment.appointmentId, "completed");
                      }}
                      src="../images/Unionblck.png"
                      className="pointer dot-image-inside"
                      alt="dots"
                    />
                    {appoinment.status && (
                      <FloatingActionMenu anchorEl={menuAnchor} className="approve-btn-1 approve-btn">
                        {(appoinment.meeting_link !== 'NULL' && appoinment.meeting_link !== '' && appoinment.is_zoom_link == "1") &&  <span className="w-100 anchor-white ">
                          <a className="width-80px d-inline-block" onClick={() => openZoomLinkPopup(appoinment)}
                            href={`javascript:void();`}>
                            Find Zoom
                          </a>
                        </span>}
                        <span className="w-100 anchor-white ">

                          {(parseInt(id) === parseInt(appoinment.medium_id) && (appoinment.session_type === "7" || appoinment.session_type === "8"
|| appoinment.session_type === "12"
|| appoinment.session_type === "13"
|| appoinment.session_type === "14"

                           )) ?
                            <a onClick={() => openContactPopup(appoinment)}
                              href={`javascript:void();`}>
                              Contact
                            </a>
                            :
                            <a
                              onClick={() =>
                                coptText(
                                  (appoinment.session_type === "1" ||
                                    appoinment.session_type === "2" || appoinment.session_type === "16" || appoinment.session_type === "7" || appoinment.session_type === "8") &&
                                    parseInt(id) ===
                                    parseInt(appoinment.client_id)
                                    ? appoinment.medium_email
                                    : appoinment.client_email
                                )
                              }
                              href={`mailto:${(appoinment.session_type === "1" ||
                                appoinment.session_type === "2" || appoinment.session_type === "16" || appoinment.session_type === "7" || appoinment.session_type === "8") &&
                                parseInt(id) === parseInt(appoinment.client_id)
                                ? appoinment.medium_email
                                : appoinment.client_email
                                }`}
                            >
                              Contact
                            </a>
                          }
                        </span>

                        {appoinment.subsession_table_id == 100 &&
                          parseInt(id) === parseInt(appoinment.medium_id) && (
                          /* onClick lives on the span, not the <a> - "Update reason"
                             wraps onto two lines, and an inline <a> only claims the
                             actual glyph area of each line, not the padded box the
                             hover highlight shows. Clicking in the gap between the
                             two lines used to miss the <a> entirely and do nothing.
                             Binding the handler here makes the whole padded box
                             (exactly what lights up on hover) clickable. */
                          <span
                            className="w-100 anchor-white "
                            onClick={() => openUpdateReasonPopup(appoinment)}
                          >
                            <a href={`javascript:void();`}>
                              Interview
                              <br/>
                              Outcome
                            </a>
                          </span>
                        )}

                        {/* <span
                          className="w-100"
                          onClick={(e) => {
                            changeHandler(
                              e,
                              2,
                              appoinment.appointmentId,
                              appoinment.client_id
                            );
                          }}
                        >
                          No Show
                        </span> */}
                      </FloatingActionMenu>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={20} style={{ padding: '48px 0', textAlign: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="8" r="4" stroke="#d5a67b" strokeWidth="1.5"/>
                      <path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" stroke="#d5a67b" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    <p style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#485257' }}>No Appointments Found</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
                </div>
        <Pagination
          rowsPerPageOptions={[5, 10, 25]}
          count={allCompletedCount}
          activeTab={"mediumcompleted"}
          getPaginationData={getPaginationData}
        />
         {/* {completedAppointments.length > 0 && <TablePagination
                  component="div"
                  rowsPerPageOptions={[5, 10, 15, 20]}
                  count={completedAppointments.length}
                  page={page - 1}
                  //  labelDisplayedRows={labelDisplayedRows}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />} */}
      </div>
      <ConfirmCancel
        deleteUser={confirmRequest}
        cancelRequest={cancelRequest}
        id={"ConfirmCancelcompletedmedium"}
      />
       <RefundDeleteModal
                deleteUser={confirmAppt}
                cancelRequest={confirmApptNo}
                id={"ConfirmRefundAppointment"}
                label={"Should client still receive feedback survey?"}
                btnLabel={"Continue"}
              />
      <NoshowBox
        noShowActive={noShowActive}
        list={attendeesList}
        noShowRequest={noshowGroupAppointment}
        noshowRemoveGroupAppointment={noshowRemoveGroupAppointment}
        noshowFrom={noshowFrom}
        refundAttendee={refundAttendee}
      />
      <WorkerBox
        noShowActive={noShowActive}
        list={attendeesList}
        noShowRequest={noshowGroupAppointment}
        noshowRemoveGroupAppointment={noshowRemoveGroupAppointment}
        noshowFrom={noshowFrom}
      />
    
      <SettlePaymentOutsitePopup
        deleteUser={settleoutsidepopupconfirmRequest}
        cancelRequest={settleoutsidepopupcancelRequest}
        id="SettlePaymentOutsitePopup"
      />
      <BackFillConfirmation
        cancelRequest={() => window.loadModal2("#BackFillConfirmation", "hide")}
        deleteUser={() => { window.loadModal2("#BackFillConfirmation", "hide"); goToMediumBackFill(backFillId) }}
        id={'BackFillConfirmation'}
      />
       <PayOptionsPopUp activePay={activePay} from="appointments" runCallback={runCallback} />
      <GiftYourMediums
        activePay={activePay}
        paymentMethodHandler={giftPaymentMethodHandler}
        setPaymentAmount={setGiftAmount}
        paymentstatus={paymentstatus}
      />
      <PayItForwardPopUp
              activePay={activePay}
              paymentMethodHandler={payItForwardHandler}
              setpayItforwardValue={setpayItforwardValue}
              setPaymentCurrency={setPaymentCurrency}
              payItforwardFixPrice={payItforwardFixPrice}
              paymentstatus={paymentstatus}
              payItforwardValue={payItforwardValue}
            />
      <Contactpopup
        activeContact={activeContact}

      />
      <ZoomLinkPopup
       activeContact={activeContact}
      />

      {/* Self-contained on purpose, not reusing .confirm-delete-wrapper
          (see ConfirmCancel/RefundDeleteModal above) - that wrapper forces
          a fixed .modal-dialog height that clips anything taller than a
          one-line confirmation, which a dropdown + two buttons would hit. */}
      <div className="update-reason-modal-wrapper">
        <div
          className="modal fade"
          id="UpdateReasonModal"
          role="dialog"
          data-backdrop="static"
        >
          <div className="modal-dialog update-reason-dialog">
            <div className="modal-content update-reason-content">
              <div className="modal-body update-reason-body">
                <h3 className="update-reason-title">Interview Outcome</h3>
                <p className="update-reason-question">What is the recommended next step?</p>
                <div className="update-reason-options" role="radiogroup" aria-label="Interview outcome">
                  {[
                    "Yes recommend for approval",
                    "Needs further evaluation",
                    "Needs more training",
                    "Not a good fit",
                    "No Show"
                  ].map((option) => (
                    <label className="update-reason-option" key={option}>
                      <input
                        type="radio"
                        name="interview-reason"
                        value={option}
                        checked={selectedReason === option}
                        onChange={(e) => setSelectedReason(e.target.value)}
                      />
                      <span>{option}</span>
                    </label>
                  ))}
                </div>
                {selectedReason === "No Show" && (
                  <p className="update-reason-note">
                    Saving will move this appointment to the No Show tab and email the
                    applicant a link to rebook their interview.
                  </p>
                )}
                <div className="update-reason-actions">
                  <button
                    type="button"
                    className="update-reason-btn update-reason-btn-secondary"
                    onClick={closeUpdateReasonPopup}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="update-reason-btn update-reason-btn-primary"
                    onClick={saveUpdateReason}
                    disabled={!selectedReason || savingReason}
                  >
                    {savingReason ? "Saving..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
